import React from "react";
import { Clock } from "lucide-react";

/* HQ , generic "Coming Soon" placeholder.
   Used so every HQ section renders inside the same layout without
   bouncing to a different page. We'll wire up real content later. */
const AUBERGINE  = "var(--hq-deep, #5A4565)";
const PLUM       = "var(--hq-accent, #6F4A7A)";
const PARCH_EDGE = "#EFE4CC";

export default function HQComingSoon({ title = "This section", note = "" }) {
  return (
    <div data-testid="hq-coming-soon" style={{ color: AUBERGINE }} className="space-y-5">
      <header>
        <div className="text-[10px] tracking-[0.45em] uppercase font-semibold" style={{ color: PLUM }}>
          ✦ Heritage Headquarters
        </div>
        <h1 className="text-4xl mt-1.5 leading-tight" style={{ color: AUBERGINE }}>{title}</h1>
      </header>

      <div
        className="bg-white border rounded-md p-10 text-center"
        style={{ borderColor: PARCH_EDGE }}
      >
        <div
          className="mx-auto w-14 h-14 rounded-full border-2 flex items-center justify-center mb-4"
          style={{ borderColor: PLUM }}
        >
          <Clock className="w-6 h-6" style={{ color: PLUM }} />
        </div>
        <h2 className="text-2xl mb-2" style={{ color: AUBERGINE }}>Coming soon</h2>
        <p className="text-sm italic opacity-70 max-w-md mx-auto leading-relaxed">
          {note || "We're rebuilding this section. It'll be back shortly , in the meantime please use Contact Heritage if you need a hand."}
        </p>
      </div>
    </div>
  );
}
